// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#onboarding-step3-container p {
    margin-bottom: 0;
  }
  #onboarding-step3-container .sentence1 {
    align-self: center;
  }
  #onboarding-step3-container .broad-container {
    font-size: 16px;
    font-weight: 100;
    margin-right: 2vw;
    max-width: 840px;
    display: flex
  }
  @media (max-width: 707px) {
  #onboarding-step3-container .broad-container {
      margin-right: 0
  }
    }
  #onboarding-step3-container .getting-started__header {
    font-size: 24px;
    font-weight: 400;
    margin-top: 0px;
    margin-bottom: 30px;
  }
  #onboarding-step3-container .header {
    font-size: 34px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 20px
  }
  @media (max-width: 707px) {

  #onboarding-step3-container .header {
      font-size: 24px;
      margin-top: 10px;
      margin-bottom: 15px
  }
    }
  #onboarding-step3-container .main-flex-column {
    display: flex;
    flex-direction: column;
  }
  #onboarding-step3-container .mobile-icon-and-line-break {
    display: flex;
  }
  #onboarding-step3-container #paypal-folded {
    display: flex;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  #onboarding-step3-container #paypal-text {
    padding-left: 15px;
    margin-top: 20px;
    margin-bottom: 15px
  }
  @media (max-width: 707px) {
  #onboarding-step3-container #paypal-text {
      margin-top: 10px
  }
    }
  #onboarding-step3-container .icon-container {
    transition: transform 0.3s ease;
  }
  #onboarding-step3-container .icon-container.rotated {
    transform: rotate(90deg);
  }
  #onboarding-step3-container .wrap-on-mobile {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 80%
  }
  @media (max-width: 707px) {

  #onboarding-step3-container .wrap-on-mobile {
      flex-direction: column;
      width: 100%
  }
    }
`, "",{"version":3,"sources":["webpack://./src/pages/Onboarding/Step3.pcss"],"names":[],"mappings":"AAIE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;EAIF;EAHE;EANF;MAOI;EAEJ;IADE;EAEF;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;EAMF;EALE;;EALF;MAMI,eAAe;MACf,gBAAgB;MAChB;EAEJ;IADE;EAGF;IACE,aAAa;IACb,sBAAsB;EACxB;EAEA;IACE,aAAa;EACf;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB;EAIF;EAHE;EAJF;MAKI;EAEJ;IADE;EAEF;IACE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB;EAKF;EAJE;;EALF;MAMI,sBAAsB;MACtB;EAEJ;IADE","sourcesContent":["$margin-for-icon: 180px;\n$mobile: 707px;\n\n#onboarding-step3-container {\n  p {\n    margin-bottom: 0;\n  }\n  .sentence1 {\n    align-self: center;\n  }\n  .broad-container {\n    font-size: 16px;\n    font-weight: 100;\n    margin-right: 2vw;\n    max-width: 840px;\n    display: flex;\n    @media (max-width: $mobile) {\n      margin-right: 0;\n    }\n  }\n  .getting-started__header {\n    font-size: 24px;\n    font-weight: 400;\n    margin-top: 0px;\n    margin-bottom: 30px;\n  }\n\n  .header {\n    font-size: 34px;\n    font-weight: 700;\n    margin-top: 0;\n    margin-bottom: 20px;\n    @media (max-width: $mobile) {\n      font-size: 24px;\n      margin-top: 10px;\n      margin-bottom: 15px;\n    }\n  }\n\n  .main-flex-column {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mobile-icon-and-line-break {\n    display: flex;\n  }\n\n  #paypal-folded {\n    display: flex;\n    margin-top: 10px;\n    margin-bottom: 5px;\n  }\n  #paypal-text {\n    padding-left: 15px;\n    margin-top: 20px;\n    margin-bottom: 15px;\n    @media (max-width: $mobile) {\n      margin-top: 10px;\n    }\n  }\n  .icon-container {\n    transition: transform 0.3s ease;\n  }\n  .icon-container.rotated {\n    transform: rotate(90deg);\n  }\n\n  .wrap-on-mobile {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    width: 80%;\n    @media (max-width: $mobile) {\n      flex-direction: column;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
